export const UPDATE_PROJECT_INFO_ID = 'fulcrum/ProjectOverview/UPDATE_PROJECT_INFO_ID'
export const UPDATE_PROJECT_INFO_WORKFLOW_ID = ' fulcrum/ProjectOverview/UPDATE_PROJECT_INFO_WORKFLOW_ID'
export const UPDATE_PROJECT_INFO_DETAILS = 'fulcrum/ProjectOverview/UPDATE_PROJECT_INFO_DETAILS'
export const CLEAR_PROJECT_INFO_DETAILS = 'fulcrum/ProjectOverview/CLEAR_PROJECT_INFO_DETAILS'
export const INITIALIZE_PROJECT = 'fulcrum/ProjectOverview/INITIALIZE_PROJECT'
export const UPDATE_REDIRECT = 'fulcrum/ProjectOverview/UPDATE_REDIRECT'
